export default "__VITE_ASSET__105a0ba2__"